import React, { useEffect, useMemo, useState } from 'react'
import * as Yup from 'yup';
import { useNavigate, useLocation } from 'react-router-dom'
import { LoginConsentCopy } from './loginConsent'
import { ReactComponent as WarningIcon } from '../images/warning-icon.svg'
import { useGenerateOtpMutation } from '../lib/services/authApi'
import PageHeader from '../components/PageHeader'
import { useDispatch, useSelector } from 'react-redux'
import { closeErrorModal, openErrorModal, setError, setIsChecked, setPhone, setSuccess } from '../lib/features/OtpSlice';
import CenteredPopup from '../components/popups/CenteredPopup';
import { useFormik } from 'formik'
import { useTapClickMutation } from '../lib/middleware/TapClickApi';
import { pushCleverTapEvent } from "../lib/middleware/CtEvents";

function LoaderScreen() {
    const [generateOtp, { isLoading }] = useGenerateOtpMutation()
    const [tapClick] = useTapClickMutation()
    const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    //const phone = useMemo(() => queryParams.get('phone'), [queryParams])
    const secret = useMemo(() => queryParams.get('secret'), [queryParams]);
    const utm_source = useMemo(() => queryParams.get('utm_source'), [queryParams]);
    const { error, isErrorModalOpen, phone, isChecked, success } = useSelector((state) => state.otp)
    const handleClose = () => {
        dispatch(closeErrorModal(false));
        dispatch(setError(''))
    }
    const errorModalButtons = [
        { label: 'Close', onClick: handleClose }
    ]
    useEffect(() => {
        if (secret) {
            localStorage.setItem('secret', secret)
        }
    }, [secret]);
    useEffect(() => {
        if (utm_source) {
            localStorage.setItem('utm_source', utm_source)
        }
    }, [utm_source]);
    const validationSchema = Yup.object({
        phoneNumber: Yup.string()
            .nullable()
            .test(
                "is-not-blank",
                "Phone number cannot be blank",
                (value) => !!value
            )
            .test(
                "is-valid-length",
                "Phone number must be 10 digits long",
                (value) => !value || /^\d{5} \d{5}$/.test(value)
            )
            .test(
                "no-nonnumeric-characters",
                "Phone number must only contain numeric digits",
                (value) => /^\d{5}( \d{5})*$/.test(value)
            )
            .test(
                "no-leading-zero",
                "Phone number must not start with zero",
                (value) => !value || /^[1-9]/.test(value)
            )
    });

    const formik = useFormik({
        initialValues: {
            phoneNumber: ''
        },
        validationSchema,
        onSubmit: async (values) => {
            generateOtpForLogin(values)
        },
    });
    /*useEffect(() => {
        if (!queryParams.has('phone')) {
            const defaultPhone = localStorage.getItem('phone');
            queryParams.set('phone', defaultPhone);
            navigate(`${location.pathname}?${queryParams.toString()}`, { replace: true });
        } else {
            localStorage.setItem('phone', phone)
        }
    }, [phone, location, navigate, queryParams])*/
    const generateOtpForLogin = async () => {
        try {
            const result = await generateOtp({ phone: phone.split(' ').join('') })
            if (result.data && result.data.status === 'error') {
                dispatch(setError(result.data.message))
                dispatch(openErrorModal())
            } else if (result.data && result.data.http_code === '201') {
                dispatch(setError(result.data.message))
                dispatch(openErrorModal())
            } else if (result.error) {
                if (result.error.message) {
                    dispatch(setError(result.error.message))
                } else {
                    dispatch(setError('Please check your internet or try again later.'))
                }
                dispatch(openErrorModal())
            } else {
                dispatch(setSuccess('OTP sent successfully'))
                localStorage.setItem('phone', phone)
                localStorage.setItem('isChecked', isChecked)
                const event_name = result.data.new_user ? 'web_signup_success' : 'web_login_success'
                localStorage.setItem('loginpage_event_name', event_name)
                const event_property = {Source: window.localStorage.getItem('utm_source'), Phone:`+91${phone.split(' ').join('')}`}
                await pushCleverTapEvent({event_name, event_property})
                setTimeout(() => {
                    dispatch(setSuccess(''))
                    navigate(`/login?utm_source=${utm_source}`);
                }, 1000);
            }
        } catch (error) {
            dispatch(setError('Something went wrong. Please try again later.'));
            dispatch(openErrorModal())
        }
    }

    return (
        <div className={`external-wrapper phone-screen ${isKeyboardOpen ? 'keyboard-active' : ''}`}>
            <CenteredPopup
                isOpen={isErrorModalOpen}
                buttons={errorModalButtons}
                onClose={handleClose} icon={<WarningIcon />}>
                <p>{error}</p>
            </CenteredPopup>
            <div className='page-content'>
                <PageHeader back={false} />
                <div className='page-heading'>
                    <h2 className='page-title'>Please enter your mobile number</h2>
                </div>

                <form onSubmit={formik.handleSubmit} noValidate>
                    <div className="input-wrapper">
                        <input
                            type="text"
                            name="phoneNumber"
                            minLength={11}
                            maxLength={11}
                            inputMode="numeric"
                            placeholder=" "
                            value={formik.values.phoneNumber}
                            onChange={(e) => {
                                const value = e.target.value ? e.target.value.replace(/[^0-9]/g, "") : '';
                                const formattedValue = value ? value
                                    .match(/.{1,5}/g)
                                    ?.join(" ")
                                    .slice(0, 11) : '';
                                formik.setFieldValue("phoneNumber", formattedValue);
                                dispatch(setPhone(formattedValue));
                            }}
                            onBlur={(e) => {
                                formik.handleBlur(e);
                                setTimeout(() => {
                                    setIsKeyboardOpen(false);
                                }, 1000);
                            }}
                            onFocus={() => setIsKeyboardOpen(true)}
                            className={`form-control`}
                        />
                        <label>Enter mobile number*</label>
                        {formik.errors.phoneNumber && formik.touched.phoneNumber && (
                            <div className="error">{formik.errors.phoneNumber}</div>
                        )}
                        {success && <div className="success">{success}</div>}
                    </div>
                    <div className='consent-check'><label><div className={`checkbox ${isChecked ? 'checked' : ''}`}><input type="checkbox" checked={isChecked} onChange={() => dispatch(setIsChecked(!isChecked))} /></div> <LoginConsentCopy /></label></div>
                    <div className='bottom-footer ps-0 pe-0'>
                        <p className='red-text'>Akara Capital Advisors Private Limited</p>
                        <p className='tm-text'>Trademark of EQX Analytics Private Limited</p>
                        <button type='submit' className={`btn btn-primary ${!isChecked || isLoading ? 'disabled' : ''}`}>Continue</button>
                    </div>
                </form>
                {/*<div className='loader-wrapper'>
                    <div className='loader'></div>
                    <p>Loading...</p>
                </div>*/}
            </div>
        </div>
    )
}

export default LoaderScreen